import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { reviewsSelector } from '../../../../../store/slices/reviews';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import { Stack } from '@mui/material';
import _ from 'lodash';
import { isValidJSON } from '../reviewUtils';

const PHI = () => {
 
  const { reviewTopicDetails, similarReviews } = useSelector(reviewsSelector);
  const [isPhiObj, setIsPhiObj] = React.useState(false);


  // const columns = useMemo(() => [
  //   {
  //     header: 'PHI Instances',
  //     accessorKey: 'phiInstances', 
  //     Cell: ({ row }) => {
  //       const phi = row?.original?.phi; 
  //       const instances = phi?.PHIInstances || []; 
  //       return (
  //         <Stack>
  //           {_.map(instances, (it, index) => (
  //             <li key={index}>{it}</li>
  //           ))}
  //         </Stack>
  //       );
  //     }
  //   },
  //   {
  //     header: 'Reasoning',
  //     accessorKey: 'reasoning', 
  //     Cell: ({ row }) => {
  //       const phi = row?.original?.phi;
  //       return <div>{phi?.Reasoning}</div>; 
  //     }
  //   }
  // ], []);


  const columns = useMemo(() => [
  {
      header: 'PHI Phrase', 
      accessorKey: 'PHIInstances', 
      width: 60,
      Cell: ({ row }) => {
           const phiInstances = row?.original['PHIInstances'] || [];        
           return (
            <Stack><ul style={{paddingLeft: isPhiObj?'8px':'12px', margin:'0'}}>{_.map(phiInstances, (instance, index) => <li key={index} style={{listStyle:isPhiObj?'none':'disc'}}>{instance}</li>)}</ul></Stack>
          );
      }
  },
  { 
      header: 'Reasoning', 
      accessorKey: 'Reasoning' 
  },
], []);


  // const tableData = useMemo(() => {
  //   const phiData = similarReviews?.agents?.phi;
  //   if (phiData && typeof phiData === 'string') {
   
  //       const parsedPhiData = JSON.parse(phiData);
  //       debugger
  //       return [
  //         {
  //           ...parsedPhiData, 
  //           phi: parsedPhiData.PHI 
  //         }
  //       ];
      
  //       return []; 
      
  //   }

  //   return [];
  // }, [similarReviews?.agents?.phi]);
  

  const tableData=useMemo(()=>{
    if(!similarReviews?.agents){
        return []
    }
    const phiData = similarReviews?.agents?.phi;
    const parsePhiData = isValidJSON(phiData) ? JSON.parse(phiData) : null;
    let dt = parsePhiData?.PHI
    const phiInstances = dt?.PHIInstances || [];
    
    const resoning = dt?.reasoning || '';
    const objPhi = _.every(phiInstances, _.isObject);
    if(objPhi){
      setIsPhiObj(true);
      return _.map(phiInstances, item => {
        if(_.isObject(item)){
          return {
            PHIInstances: [item?.PHIPhrase || ''],
            Reasoning: item?.PHIReasoning || ''
          }
        }
      })
    }

    setIsPhiObj(false);
     return [dt]

  },[similarReviews?.agents])

console.log('tableData', tableData);

  const table = useMaterialReactTable({
    columns,
    data: tableData,
    enableFullScreenToggle: false,
    enableDensityToggle: false,
    enableColumnFilters: false,
    enableTopToolbar: false,
    enableBottomToolbar: false,
    enableSorting: false,
    enableHiding: false,
    enableColumnActions: false,
    muiTableContainerProps: {
      sx: {
        maxHeight: 'unset'
      }
    },
    muiTablePaperProps: {
      className: 'std_table review-requests',
      sx: { boxShadow: 'none' }
    },
    muiTableBodyCellProps: {
      sx: { border: 'none' }
    }
  });

  return (
    <>
      <MaterialReactTable table={table} />
    </>
  );
};

export default PHI;
